import { PdpSellerAvatar } from 'src/images/muse/PdpSellerAvatar'

export function MusePdpAvatar() {
  return (
    <span className="relative block size-12 restructure-small-desktop:size-16">
      <PdpSellerAvatar className="size-12 restructure-small-desktop:size-16" />
      <span
        aria-hidden
        className="absolute bottom-0 right-[3px] size-[10.5px] rounded-round border border-restructure-background-primary bg-[#22c55e] restructure-small-desktop:size-3.5 restructure-small-desktop:border-md"
      />
    </span>
  )
}
